export default __webpack_public_path__ + "static/media/logo.b803f833.png";